import { Box, Button, ButtonProps, Heading, Text } from "@vinomofo/components";

import * as React from "react";
import bannerImage from "./banner-image.png";
import mobileBannerImage from "./subscribe-banner-image.gif";
import styled from "styled-components";

export interface NotificationBannerProps extends ButtonProps {
  onClick: (e: React.MouseEvent) => void;
  title: string;
  message: string | React.ReactNode;
  isPromotion?: boolean;
}

const NotificationBannerWrapper = styled(Button)<{ isPromotion?: boolean }>`
  img {
    display: block;
    background-size: cover;
    height: 100%;
    background-repeat: no-repeat;
    width: 100%;
    border-radius: 5px;
  }
  div {
    display: ${({ isPromotion }) => (isPromotion ? "block" : "none")};
  }
`;

const Inner = styled(Box)`
  position: relative;

  &::after {
    content: "";
    background-image: url(${bannerImage});
    background-size: cover;
    position: absolute;
    bottom: 0;
    right: 20px;
    width: 136px;
    height: 115px;
  }
`;

export const NotificationBanner = ({
  onClick,
  backgroundColor = "papaSmurf",
  color = "white",
  title,
  message,
  isPromotion = false,
  ...rest
}: NotificationBannerProps): JSX.Element => {
  return (
    <NotificationBannerWrapper
      onClick={onClick}
      backgroundColor={backgroundColor}
      borderRadius="5px"
      color={color}
      isPromotion={isPromotion}
      {...rest}
    >
      <Inner padding="20px 190px 20px 30px" textAlign="left">
        <Heading as="h5" color="inherit" fontSize={[2, 4]} lineHeight="1.4">
          {title}
        </Heading>
        <Text color="inherit" fontSize={[1, 2]}>
          {message}
        </Text>
      </Inner>
      {!isPromotion && (
        <img src={mobileBannerImage} alt="Subscribe Banner image" />
      )}
    </NotificationBannerWrapper>
  );
};
